import { render } from "./EducationSection.vue?vue&type=template&id=000312a4&ts=true"
import script from "./EducationSection.vue?vue&type=script&lang=ts"
export * from "./EducationSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__